<template>
  <img
    v-if="imageUrl !== null"
    :src="imageUrl"
    class="fapi-item-image"
    style="max-width: 250px; max-height: 150px; border-radius: 5px"
  />
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import FormItem from "@/module/FormItem";

export default Vue.extend({
  name: "ItemImage",

  props: {
    item: {
      type: Object as PropType<FormItem>,
      required: true,
    },
  },

  computed: {
    imageUrl(): string | null {
      return this.item.imageUrl;
    },
  },
});
</script>
